<mat-card>
  <mat-card-header>
    <mat-card-title>{{pageType | capitalize }} Solution</mat-card-title>
  </mat-card-header>

  <form>
    <mat-card-content>

      <mat-form-field>
        <input matInput placeholder="Title" [formControl]="solutionForm.get('title')" required>
        <mat-error *ngIf="formService.controlHasError( solutionForm.get('title'), 'required')">This field is required
        </mat-error>
      </mat-form-field>

        <mat-card-subtitle>Correct Answer</mat-card-subtitle>
        <app-ck-editor [formControl]="solutionForm.get('correctAnswer')" [inline]="true"></app-ck-editor>
      <mat-error *ngIf="formService.controlHasError( solutionForm.get('correctAnswer'), 'required')">This field is required
      </mat-error>


      <mat-card-subtitle *ngIf="wrongAnswersString.length > 0">Incorrect Answers</mat-card-subtitle>
      <ul>
        <li *ngFor="let index of arrayOfWrongAnswerIndex">
          <div class="w-100 d-inline-block">
            <app-ck-editor [(ngModel)]="wrongAnswersString[index - 1]" [inline]="true" name="ckeditor{{index -1 }}">
          </app-ck-editor>
          </div>
          <button *ngIf="arrayOfWrongAnswerIndex.length > 1" color="primary" mat-icon-button class="d-inline-block"
                  (click)="removeWrongAnswer(index - 1)">
            <mat-icon>delete</mat-icon>
          </button>
        </li>
      </ul>
      <mat-error *ngIf="formService.controlHasError( solutionForm.get('wrongAnswers'), 'required')">This field is required
      </mat-error>
      <mat-error *ngIf="formService.controlHasError( solutionForm.get('wrongAnswers'), 'needsThreeWrongAnswers')">
        3 wrong answers are required.
      </mat-error>
      <button mat-raised-button color="secondary" [disabled]="wrongAnswersString.length >= 3" (click)="addWrongAnswer()"> Add Incorrect Answer</button>
    </mat-card-content>

    <mat-card-actions class="solution-actions" align="end">
      <button mat-raised-button color="primary" [disabled]="!solutionForm.valid || isSubmitting" (click)="submitForm()">{{this.pageType.toUpperCase()}}</button>
    </mat-card-actions>
  </form>
</mat-card>






